import { configureStore } from "@reduxjs/toolkit";
import { createPromise } from "redux-promise-middleware";
import { PROMISE_TYPE_SUFFIXES } from "stores/redux/actions/types";
import rootReducer from "stores/redux/reducers";
import { apiSlice } from "./apis/apiSlice";

const devMode = process.env.NODE_ENV === "development";

const promiseMiddleWare = createPromise({
  promiseTypeSuffixes: PROMISE_TYPE_SUFFIXES
});

const store = configureStore({
  reducer: rootReducer,
  devTools: devMode,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }).concat(promiseMiddleWare, apiSlice.middleware)
});

export default store;
